// Real example screenshots shown as a slideshow while a scan runs — served
// from public/scan-loader-shots/ (static assets, not bundled) so this list
// only carries filenames.
export const SCAN_LOADER_SHOTS = [
  "broker-gurgaon-2cr-buyer-brief.png",
  "broker-hyderabad-willing-to-pay-brokerage.png",
  "ca-funded-founder-switching-ca.png",
  "ca-gst-notice-immediate-help.png",
  "ca-hyderabad-startup-incorporation-ask.png",
  "ca-services-free-help-itr-tds-gst.png",
  "ca-services-looking-startup-focused-ca-india.png",
  "d2c-electronics-best-noise-cancellation-earphones-india.png",
  "d2c-electronics-looking-wired-earphones-under-2000.png",
  "d2c-electronics-suggest-best-earbuds-under-2k.png",
  "d2c-skincare-deconstruct-moisturizer-real-or-sus.png",
  "d2c-skincare-honest-review-re-equil-ultra.png",
  "d2c-skincare-how-start-korean-skincare-brand.png",
  "dental-bangalore-kdoc-complaint.png",
  "dental-bengaluru-aligner-quote-compare.png",
  "dental-clinic-am-i-being-overcharged-by.png",
  "dental-clinic-braces-ya-aligners-look-se.png",
  "dental-clinic-dentist-shared-invisalign-outcome-simulation.png",
  "dental-clinic-thinking-about-same-day-dental.png",
  "dental-delhi-west-delhi-recs.png",
  "dental-failed-invisalign-switching-patient.png",
  "dental-mumbai-kandivali-root-canal.png",
  "derma-bangalore-wedding-in-a-month.png",
  "derma-india-good-bad-list.png",
  "derma-jaipur-mahesh-nagar-hairloss.png",
  "fitness-chatgpt-diet-verify.png",
  "fitness-coaching-diet-ozempic-weight-loss-m35.png",
  "fitness-coaching-how-much-can-certified-fitness.png",
  "fitness-coaching-how-you-guys-using-ai.png",
  "fitness-coaching-shocking-truth-about-online-fitness.png",
  "fitness-coaching-should-i-prepare-govt-job.png",
  "fitness-wedding-deadline-lead.png",
  "fmcg-8pc-margin-payment-delay-pain.png",
  "fmcg-distribution-how-do-small-garment-manufacturers.png",
  "ielts-bigbrand-trust-gap.png",
  "ielts-coaching-best-ielts-coaching-strategy-delhi.png",
  "ielts-coaching-welcome-future-nursing-india.png",
  "ielts-hyderabad-coaching-ask.png",
  "interior-3d-quote-fair-or-not.png",
  "interior-bangalore-2bhk-8-10l-lead.png",
  "interior-bangalore-5lakh-burned.png",
  "interior-design-absolute-shameless-company-i-am.png",
  "interior-design-looking-interior-designers.png",
  "interior-hyderabad-2bhk-cost-ask.png",
  "interior-mumbai-brand-comparison.png",
  "local-dental-best-affordable-dental-clinic-mumbai.png",
  "local-dental-clinic-recommendations-delhi-need-pontic.png",
  "local-dental-dentist-recommendation-chembur.png",
  "local-dental-dentist-recommendations-kolkata.png",
  "local-dental-ramapamposh-x.png",
  "local-dermatologist-25m-dermatologist-recommendations.png",
  "local-dermatologist-27f-dermatologist-recommendations-bangalore.png",
  "local-dermatologist-bangalore-dermatologist-suggestions-reasonable.png",
  "local-dermatologist-dermatologist-recommendation-electrolysis-hair-removal.png",
  "local-dermatologist-good-dermatologist-jaipur-any-recommendations.png",
  "local-dermatologist-m26-good-dermatologist-bangalore.png",
  "local-dermatologist-need-dermatologist-bangalore-acne-scars.png",
  "local-dermatologist-need-recommendations-good-dermatologist-delhi.png",
  "local-interior-does-anyone-know-any-interior.png",
  "local-interior-got-2bhk-interiors-done-whitefield.png",
  "local-interior-interior-design-recommendation-request.png",
  "local-interior-kolkata-interior-designer-reco.png",
  "local-interior-looking-interior-designer-recommendations-bren.png",
  "local-interior-looking-reviews-copper-trunk-design.png",
  "local-interior-modular-kitchen-cost-india-2026.png",
  "local-interior-realistically-what-should-2bhk-basic.png",
  "local-wedding-cheated-by-wedding-photographer-shikhar.png",
  "local-wedding-looking-recommendations-wedding-photographers-kolkata.png",
  "local-wedding-very-close-reaching-1-crore.png",
  "local-wedding-wedding-photographers-videographers-mumbai.png",
  "real-estate-broker-builder-not-delivering-flat-construction.png",
  "real-estate-broker-hi-delhi-people-i-need.png",
  "real-estate-broker-yesterday-600-client-who-paid.png",
  "restaurant-kolkata-sushi-date-budget.png",
  "restaurants-pos-software-ask-thread.png",
  "saas-billing-looking-connect-accountants-using-tally.png",
  "saas-billing-zoho-invoice-vs-zoho-books.png",
  "saas-offline-billing-spec-ask.png",
  "saas-tally-vs-cloud-buyer-ask.png",
  "salon-bangalore-short-maadi-bhai.png",
  "sell-to-restaurants-looking-sales-distribution-partners-commission.png",
  "sell-to-restaurants-planning-start-small-beef-only.png",
  "sell-to-restaurants-restaurant-owners-whats-most-frustrating.png",
  "sell-to-restaurants-why-do-most-pos-companies.png",
  "skincare-lipbalm-brand-vs-ask.png",
  "skincare-sunscreen-oily-sweaty-ask.png",
  "study-abroad-consulting-complete-guide-indian-students-planning.png",
  "study-abroad-consulting-honest-review-these-mbbs-abroad.png",
  "study-abroad-consulting-i-am-llb-student-from.png",
  "study-abroad-consulting-upgrad-study-abroad-actually-good.png",
  "study-abroad-consulting-which-one-better-option-study.png",
  "study-abroad-pune-counselor-ask.png",
  "study-abroad-scam-warning.png",
  "study-abroad-yocket-mislead-lead.png",
  "trading-beginner-seeking-mentor.png",
  "trading-education-ayushi-verma-linkedin.png",
  "trading-education-rohit-k-linkedin.png",
  "trading-education-welcome-r-indiatradinginstitute-introduce-yourself.png",
  "trading-education-which-best-mode-learn-f.png",
  "trading-scam-fear-buyer.png",
  "webdev-agency-we-re-currently-looking-collaborate.png",
  "webdev-family-business-india-only-ask.png",
  "wedding-jaipur-monument-fee-hike.png",
  "wedding-lucknow-candid-flexible-budget.png",
  "wedding-noida-november-lead.png",
];

// Fisher-Yates — a fresh shuffled order per scan, not the same order every time.
export function shuffledShots() {
  const arr = [...SCAN_LOADER_SHOTS];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
